import React, { Component } from "react"
import Typography from "@mui/material/Typography"
import Button from "@mui/material/Button"
import ArrowBack from "@mui/icons-material/ArrowBack"
import ArrowForward from "@mui/icons-material/ArrowForward"
import Check from "@mui/icons-material/Check"
import { sanitizeYaml } from "../../utilities"
import linkifyHtml from "linkify-html"

const CustomListItem = ({
  name,
  index,
  listIndex,
  listCount,
  roomCode,
  participantId,
  isCorrect,
}) => {
  const interact = (element, newList) => {
    fetch(
      window.location.pathname === "/admin"
        ? `${process.env.REACT_APP_SERVER_URL}/room/interact?roomCode=${roomCode}`
        : `${process.env.REACT_APP_SERVER_URL}/room/interact?roomCode=${roomCode}&participantId=${participantId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          element,
          newList,
        }),
      }
    )
  }

  return (
    <div
      style={{
        display: "flex",
        textTransform: "none",
        marginTop: "16px",
        borderRadius: "24px",
        background: "rgba(255, 255, 255, .8)",
        backdropFilter: "blur(16px)",
      }}
    >
      {window.location.pathname === "/admin" && isCorrect ? (
        <div
          style={{
            width: "80px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Check style={{ fontSize: "2rem" }} />
        </div>
      ) : listIndex === 0 ? (
        <div
          style={{
            width: "80px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
      ) : (
        <Button
          style={{
            width: "80px",
            color: "black",
            borderRadius: 0,
            borderTopLeftRadius: "inherit",
            borderBottomLeftRadius: "inherit",
          }}
          onClick={() =>
            interact(index, String.fromCharCode(65 + listIndex - 1))
          }
        >
          <ArrowBack style={{ fontSize: "2rem" }} />
        </Button>
      )}
      <Typography
        variant="h4"
        style={{
          textAlign: "center",
          fontWeight: 300,
          padding: "24px",
          width: "calc(100% - 208px)",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        dangerouslySetInnerHTML={{
          __html: linkifyHtml(sanitizeYaml(name), {
            target: "_blank",
            attributes: {
              class: "underlineOnHover",
            },
          }),
        }}
      />
      {listIndex === listCount - 1 ||
      (window.location.pathname === "/admin" && isCorrect) ? (
        <div
          style={{
            width: "80px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
      ) : (
        <Button
          style={{
            width: "80px",
            color: "black",
            borderRadius: 0,
            borderTopRightRadius: "inherit",
            borderBottomRightRadius: "inherit",
          }}
          onClick={() =>
            interact(index, String.fromCharCode(65 + listIndex + 1))
          }
        >
          <ArrowForward style={{ fontSize: "2rem" }} />
        </Button>
      )}
    </div>
  )
}

export default class MultipleLists extends Component {
  render() {
    const { lists, slideState, roomCode, participantId } = this.props

    const mergedList = lists.flatMap(({ list }) => list)

    let shuffledLists = []

    Object.keys(slideState)
      .filter((key) => key.startsWith("positions"))
      .forEach((positions, index) =>
        slideState[positions].forEach((position) => {
          if (!shuffledLists[index]) {
            shuffledLists[index] = []
          }

          return (shuffledLists[index][shuffledLists[index].length] =
            mergedList[position])
        })
      )

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          maxWidth: lists.length === 2 ? "1280px" : "unset",
          padding: "0 32px",
          gridGap: "32px",
          display: "flex",
          overflow: "auto",
        }}
      >
        {lists.map(({ name, list }, index) => (
          <div
            style={{
              minWidth: "384px",
              height: "calc(100% - 64px)",
              padding: "32px 0",
              display: "flex",
              flexDirection: "column",
              flex: 1,
              overflow: "auto",
            }}
          >
            <div
              style={{
                textAlign: "center",
                textTransform: "none",
                padding: "24px 32px",
                borderRadius: "24px",
                background: "rgba(255, 255, 255, .8)",
                backdropFilter: "blur(16px)",
              }}
            >
              <Typography
                variant="h4"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                dangerouslySetInnerHTML={{
                  __html: linkifyHtml(sanitizeYaml(name), {
                    target: "_blank",
                    attributes: {
                      class: "underlineOnHover",
                    },
                  }),
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
              }}
            >
              {(shuffledLists[index] || []).map((nome) => (
                <CustomListItem
                  name={nome}
                  isCorrect={list.includes(nome)}
                  index={mergedList.indexOf(nome)}
                  listIndex={index}
                  listCount={lists.length}
                  roomCode={roomCode}
                  participantId={participantId}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  }
}
